// File upload in ThemeAI — a CSV or Excel file as a task's data, a CSV of
// corrected codes uploaded back, and a code frame uploaded as a file — is
// hidden for now (Matt, 24 Sep: there is a lot of complexity to think through
// first; a frame file has no agreed format yet, #1523 item 9). Tasks already made from a file
// still open and show their file. Set this to true to bring the controls back.
export const THEMEAI_FILE_UPLOAD = false
